import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import fetchWithReauth from '~/redux/baseQueryWithReauth';
import { getTokenDetails } from '~/redux/utils';

const authBaseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_AUTH_SVC_ENDPOINT,
  prepareHeaders: (headers) => {
    const locale = location.pathname.split('/')[1];
    const { access_token } = getTokenDetails();
    if (access_token !== undefined) {
      headers.set('authorization', `Bearer ${access_token}`);
      headers.set(
        'User-Agent',
        `Aqarmap My Account - ${process.env.REACT_APP_APP_VERSION}`,
      );
    }
    headers.set('Accept-Language', locale);
    return headers;
  },
});

export const authApi = createApi({
  reducerPath: 'auth-api',
  baseQuery: fetchWithReauth(authBaseQuery),
  endpoints: () => ({}),
  tagTypes: ['userProfile'],
});

export const authApiSlice = authApi.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query<any, void>({
      query: () => ({ url: 'api/user/profile' }),
      providesTags: ['userProfile'],
    }),
    changeUserName: builder.mutation<any, FormData>({
      query: (formData) => {
        return { url: 'api/user/change-name', method: 'POST', body: formData };
      },
      invalidatesTags: (_, error) => (error ? [] : ['userProfile']),
    }),
    updateEmail: builder.mutation<any, FormData>({
      query: (formData) => {
        return { url: 'api/user/change-email', method: 'POST', body: formData };
      },
      invalidatesTags: (_, error) => (error ? [] : ['userProfile']),
    }),
    updatePassword: builder.mutation<any, FormData>({
      query: (formData) => {
        return {
          url: 'api/user/change-password',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (_, error) => (error ? [] : ['userProfile']),
    }),
    logoutFromAllDevices: builder.mutation<any, void>({
      query: () => {
        return {
          url: 'api/token/revoke/all',
          method: 'DELETE',
        };
      },
    }),
    changeUserPhone: builder.mutation<any, FormData>({
      query: (formData) => {
        return { url: 'api/user/change-phone', method: 'POST', body: formData };
      },
      invalidatesTags: (_, error) => (error ? [] : ['userProfile']),
    }),
    sendOtp: builder.mutation<any, FormData>({
      query: (formData) => {
        return {
          url: '/api/user/phone/verification/send-otp',
          method: 'POST',
          body: formData,
        };
      },
    }),
    verifyOtp: builder.mutation<any, FormData>({
      query: (formData) => {
        return {
          url: '/api/user/phone/verification/verify-otp',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (_, error) => (error ? [] : ['userProfile']),
    }),
  }),
});

export const {
  useUpdateEmailMutation,
  useUpdatePasswordMutation,
  useLogoutFromAllDevicesMutation,
  useChangeUserPhoneMutation,
  useGetUserProfileQuery,
  useChangeUserNameMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
} = authApiSlice;
